// extracted by mini-css-extract-plugin
export default {"root":"nNrQYkbRseGxIGZp_zpL","row":"VaTrZUFBIsWRVZuCrvlR X_gKw8iu5ccD29QeTAez","desktop-title":"lLLDP5TyD9xLPUxze8bo","desktopTitle":"lLLDP5TyD9xLPUxze8bo"};